import {
  createNgReactBridgeDirective,
  createNgReactBridgeFactory,
  createNgReactBridgeController,
  createNgReactBridgeConstant
} from '../../react-bridge'
import { ApiKeysWithMultipleUsers } from '../../../components/keys-settings/api-keys'
import { ApiAuthorizationServiceFactory } from './api-authorization.service'
import { APIKeyCtrl } from './api-key.controller'

createNgReactBridgeFactory(
  'apiAuthorizationService',
  ApiAuthorizationServiceFactory
)

export const apiKeys = createNgReactBridgeDirective(
  'reactApiKeys',
  [],
  ApiKeysWithMultipleUsers,
  [
    'apiKey',
    'contrastURL',
    'authHeader',
    'agentServiceKey',
    'agentUsername',
    'token',
    'onRotateAgentServiceKey',
    'onRotateApiKey',
    'onCopyAPIRequest',
    'organization',
    'role',
    'checkRole'
  ]
)

createNgReactBridgeController('APIKeyCtrl', APIKeyCtrl)

export const apiKeyTypes = {
  API_KEY: 'API_KEY',
  AGENT_USER_SERVICE_KEY: 'AGENT_USER_SERVICE_KEY ',
  USER_SERVICE_KEY: 'USER_SERVICE_KEY'
}

createNgReactBridgeConstant('KEY_TYPES', apiKeyTypes)
